// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__UOPsx","selected":"Chip_selected__1Q_wH"};